var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-wrapper",style:({ 'aspect-ratio': _vm.aspect_ratio })},[_c('iframe',{staticClass:"iframe",style:(_vm.iframe_styles),attrs:{"src":_vm.src,"loading":"lazy","title":_vm.title,"allow":"encrypted-media; fullscreen;"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }